import { render } from "./ConfigurationOptionsItem.vue?vue&type=template&id=cfd46a32&scoped=true"
import script from "./ConfigurationOptionsItem.vue?vue&type=script&lang=js"
export * from "./ConfigurationOptionsItem.vue?vue&type=script&lang=js"

import "./ConfigurationOptionsItem.vue?vue&type=style&index=0&id=cfd46a32&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfd46a32"]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem});
